(function(){
if(window.__flashLPInit){return;}window.__flashLPInit=true;
(function(){
  var tabs=document.querySelectorAll('.flp-range-tab');
  var value=document.getElementById('rangeValue');
  var context=document.getElementById('rangeContext');
  tabs.forEach(function(tab){tab.addEventListener('click',function(){
    tabs.forEach(function(t){t.classList.remove('flp-active');t.setAttribute('aria-pressed','false')});tab.classList.add('flp-active');tab.setAttribute('aria-pressed','true');
    if(tab.dataset.model==='single'){
      value.textContent='~40 MI';
      context.textContent='Real-world single-battery range in normal San Francisco mixed riding. Maximum speed is about 60 mph.';
    }else{
      value.textContent='70–85 MI';
      context.textContent='Real-world dual-battery range in normal San Francisco traffic, including hills and roughly 10% freeway riding.';
    }
  })});

  var skuCards=[].slice.call(document.querySelectorAll('.flp-sku-card'));
  var quizOptions=[].slice.call(document.querySelectorAll('.flp-quiz-option'));
  var selectedName=document.getElementById('selectedName');
  var selectedDescription=document.getElementById('selectedDescription');
  var recommendation=document.getElementById('chargeRecommendation');
  var reason=document.getElementById('chargeReason');
  var saveMiles=document.getElementById('saveMiles');
  var saveGas=document.getElementById('saveGas');
  var saveElectric=document.getElementById('saveElectric');
  var saveLabor=document.getElementById('saveLabor');
  var saveYearsRange=document.getElementById('saveYearsRange');
  var fitHeight=document.getElementById('fitHeight');
  var fitPresets=[].slice.call(document.querySelectorAll('.flp-fit-preset'));
  var fitRiderImage=document.getElementById('fitRiderImage');
  var fitRiderImages={
    62:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/flash-rider-fit-5ft2-tiptoe-clean-studio-v7.jpg?v=1784624736',alt:'5 foot 2 inch helmeted female rider shown seated centrally with one foot tip-toe at a stop and in normal riding posture on a black HMP FLASH'},
    67:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/flash-rider-fit-5ft7-loaded-iphone-studio-v5.jpg?v=1784434056',alt:'5 foot 7 inch helmeted rider shown feet-down and in normal riding posture on a black HMP FLASH'},
    72:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/flash-rider-fit-6ft0-loaded-iphone-studio-v5.jpg?v=1784624737',alt:'6 foot helmeted rider shown feet-down and in normal riding posture on a black HMP FLASH'},
    76:{src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/flash-rider-fit-6ft4-loaded-iphone-studio-v5.jpg?v=1784624738',alt:'6 foot 4 inch helmeted rider shown feet-down and in normal riding posture on a black HMP FLASH'}
  };
  var saveYears=5;
  var ridePresets=[].slice.call(document.querySelectorAll('.flp-ride-preset'));
  var yearOptions=[].slice.call(document.querySelectorAll('.flp-year-option'));
  var selectedSkuCard=document.querySelector('.flp-sku-card.flp-selected');
  function money(v){return '$'+Number(v).toLocaleString('en-US');}
  function inchesToText(inches){
    var feet=Math.floor(inches/12);
    var remainder=inches%12;
    return feet+"'"+remainder+'"';
  }
  function setRangeVisual(input){
    if(!input) return;
    var min=Number(input.min||0);
    var max=Number(input.max||100);
    var value=Number(input.value||0);
    var pct=((value-min)/(max-min))*100;
    input.style.setProperty('--pct', pct+'%');
  }
  function updateSavings(){
    if(!saveMiles||!saveGas||!saveElectric) return;
    var weekly=Number(saveMiles.value);
    var miles=weekly*52*saveYears;
    var gasPrice=Number(saveGas.value);
    var electricPrice=Number(saveElectric.value);
    var laborRate=saveLabor?Number(saveLabor.value):130;
    var mpg=80;                    // PCX-class, SF real-world
    var flashKwhPerMile=0.0888;    // 6.66 kWh dual pack = ~75 mi SF riding
    var gasPartsPerMile=0.018;     // OEM parts, PCX factory schedule
    var flashPartsPerMile=0.004;
    var gasHoursPerMile=0.00059;   // ~0.59 shop-hr / 1,000 mi book time
    var flashHoursPerMile=0.00016;

    var g={fuel:miles*gasPrice/mpg, parts:miles*gasPartsPerMile, labor:miles*gasHoursPerMile*laborRate};
    var f={fuel:miles*flashKwhPerMile*electricPrice, parts:miles*flashPartsPerMile, labor:miles*flashHoursPerMile*laborRate};
    g.total=g.fuel+g.parts+g.labor; f.total=f.fuel+f.parts+f.labor;
    var energySavings=Math.max(0,g.fuel-f.fuel);
    var partsSavings=Math.max(0,g.parts-f.parts);
    var laborSavings=Math.max(0,g.labor-f.labor);
    var total=energySavings+partsSavings+laborSavings;
    var monthly=total/(saveYears*12);

    document.getElementById('saveMilesOut').textContent=weekly.toLocaleString('en-US')+' miles';
    document.getElementById('saveYearsOut').textContent=saveYears+' years';
    document.getElementById('saveGasOut').textContent='$'+gasPrice.toFixed(2)+'/gal';
    document.getElementById('saveElectricOut').textContent='$'+electricPrice.toFixed(2)+'/kWh';
    if(saveLabor) document.getElementById('saveLaborOut').textContent='$'+laborRate+'/hr';
    document.getElementById('saveTotal').textContent=money(Math.round(total));
    document.getElementById('saveMonthly').textContent=money(Math.round(monthly));
    document.getElementById('saveEnergy').textContent=money(Math.round(energySavings));
    document.getElementById('saveParts').textContent=money(Math.round(partsSavings));
    document.getElementById('saveLaborSave').textContent=money(Math.round(laborSavings));
    document.getElementById('saveMilesTotal').textContent=Math.round(miles).toLocaleString('en-US')+' miles';
    document.getElementById('saveYearsText').textContent=saveYears+' years';
    var pMiles=document.getElementById('saveProfileMiles'); if(pMiles) pMiles.textContent=Math.round(miles).toLocaleString('en-US');
    var pWeekly=document.getElementById('saveProfileWeekly'); if(pWeekly) pWeekly.textContent=weekly.toLocaleString('en-US')+' miles';
    var pYears=document.getElementById('saveProfileYears'); if(pYears) pYears.textContent=saveYears+' years';

    var REF=(function(v){var st=[400,800,1500,2500,4000,6000,9000,14000,20000,30000,45000,70000,110000,170000,260000];for(var i=0;i<st.length;i++){if(v<=st[i])return st[i];}return v;})(g.total);
    function w(v){return Math.max(0.8, v/REF*92)+'%';}
    [['fuel','fuel'],['parts','parts'],['labor','labor'],['total','total']].forEach(function(k){
      var key=k[0];
      document.getElementById('bg_'+key).style.width=w(g[key]);
      document.getElementById('bf_'+key).style.width=w(f[key]);
      document.getElementById('bt_'+key+'_g').textContent='Gas '+money(Math.round(g[key]));
      document.getElementById('bt_'+key+'_f').textContent='FLASH '+money(Math.round(f[key]));
      var sv=Math.max(0,g[key]-f[key]);
      document.getElementById('cs_'+key).textContent='You keep '+money(Math.round(sv));
    });
    setRangeVisual(saveMiles);
    setRangeVisual(saveGas);
    setRangeVisual(saveElectric);
    if(saveLabor) setRangeVisual(saveLabor);
    if(saveYearsRange) setRangeVisual(saveYearsRange);
  }
  function updateFit(){
    if(!fitHeight) return;
    var h=Number(fitHeight.value);
    var cm=Math.round(h*2.54);
    var riderImage=fitRiderImages[h]||fitRiderImages[67];
    if(fitRiderImage&&riderImage){fitRiderImage.src=riderImage.src;fitRiderImage.alt=riderImage.alt;}
    var footingTitle='Mostly flat-foot';
    var footingShort='Mostly flat-foot';
    var footingNote='Comfortable for everyday city starts and stops.';
    var posture='Balanced upright';
    var postureNote='Natural reach to the bars with a relaxed knee bend.';
    var use='Daily commuting';
    var useNote='Practical for city rides and freeway-capable errands.';
    var confidence=74;
    var state='mostly';
    var technique='Either foot or both feet';
    var techniqueNote='Most riders in this range can comfortably stabilize the bike with both feet or use a relaxed one-foot stop.';
    var expectation='Confident everyday fit';
    var expectationNote='This is close to the sweet spot for FLASH’s approximately 31-inch seat height.';
    var summary='At a stop, a rider of this height will <b>usually feel secure and stable, with easy footing on most roads</b>. This is the sweet-spot fit range for FLASH.';
    var sub='A typical rider around this height should feel confident at stoplights, with easy reach and a relaxed upright posture.';

    if(h<=64){
      state='tip'; confidence=24;
      footingTitle='Tip-toe / one-foot stop'; footingShort='Tip-toe';
      footingNote='Most riders here will use one foot firmly down or both toes.';
      posture='Compact upright'; postureNote='Bar reach should be manageable, but the seat will feel tall.';
      use='Test ride recommended'; useNote='Technique and inseam matter more in this range.';
      technique='One foot down'; techniqueNote='Slide slightly to one side at stops and plant one foot firmly instead of forcing both feet down.';
      expectation='Seat will feel tall'; expectationNote='A real test ride is strongly recommended before ordering.';
      summary='At a stop, a rider of this height will <b>most likely rely on one-foot support or tip-toe contact</b>. The step-through shape helps, but this is not a guaranteed flat-foot fit.';
      sub='FLASH can still work for shorter riders, but stop technique, footwear and inseam make a meaningful difference.';
    }else if(h<=69){
      state='balls'; confidence=52;
      footingTitle='Balls of both feet'; footingShort='Balls of feet';
      footingNote='Partial contact on both sides, or one foot very comfortably down.';
      posture='Neutral upright'; postureNote='Comfortable bar reach with a slightly tighter knee angle.';
      use='City commuting'; useNote='A familiar fit for many modern-scooter riders.';
      technique='Both feet partial, or one foot flat'; techniqueNote='Most riders choose between partial contact on both feet or a fully planted one-foot stop.';
      expectation='Manageable with normal scooter technique'; expectationNote='Usually comfortable once the rider is familiar with one-foot stops.';
      summary='At a stop, a rider of this height will <b>usually get the balls of both feet down, or one foot down very comfortably</b>.';
      sub='This is a practical fit range for many riders who already feel comfortable on scooters.';
    }else if(h<=74){
      state='mostly'; confidence=74;
    }else{
      state='flat'; confidence=h<=75?88:95;
      footingTitle='Flat-foot confidence'; footingShort='Flat-footed';
      footingNote='Easy stoplight support with both feet.';
      posture=h<=73?'Relaxed upright':'Roomy upright';
      postureNote=h<=73?'Open knee angle and easy control reach.':'Plenty of lower-body room with a relaxed reach.';
      use='Commute + weekend'; useNote='Comfortable for longer rides, passengers and errands.';
      technique='Both feet flat'; techniqueNote='Most riders in this height range should be able to stabilize the bike easily with both feet.';
      expectation='Very easy low-speed confidence'; expectationNote='The bike should feel especially approachable at stops and parking speeds.';
      summary='At a stop, a rider of this height will <b>typically flat-foot with ease</b>. The riding position should feel roomy and relaxed.';
      sub='Riders in this band usually get the most effortless feet-down confidence.';
    }

    document.getElementById('fitHeightOut').innerHTML=inchesToText(h).replace('"','&quot;');
    document.getElementById('fitHeightMetric').textContent=cm+' cm';
    document.getElementById('fitFootingTitle').textContent=footingTitle;
    document.getElementById('fitSub').textContent=sub;
    document.getElementById('fitFootingShort').textContent=footingShort;
    document.getElementById('fitFootingNote').textContent=footingNote;
    document.getElementById('fitPosture').textContent=posture;
    document.getElementById('fitPostureNote').textContent=postureNote;
    document.getElementById('fitUse').textContent=use;
    document.getElementById('fitUseNote').textContent=useNote;
    document.getElementById('fitConfidenceText').textContent='Estimated confidence: '+confidence+'%';
    document.getElementById('fitSummary').innerHTML=summary;
    document.querySelector('.flp-fit-bar-fill').style.width=confidence+'%';
    document.getElementById('fitMarker').style.left=confidence+'%';
    document.querySelectorAll('.flp-fit-contact').forEach(function(card){card.classList.toggle('flp-active',card.dataset.state===state)});
    var tech=document.getElementById('fitTechnique'); if(tech) tech.textContent=technique;
    var techNote=document.getElementById('fitTechniqueNote'); if(techNote) techNote.textContent=techniqueNote;
    var exp=document.getElementById('fitExpectation'); if(exp) exp.textContent=expectation;
    var expNote=document.getElementById('fitExpectationNote'); if(expNote) expNote.textContent=expectationNote;
    fitPresets.forEach(function(btn){
      var isCurrent=Number(btn.dataset.height)===h;
      btn.classList.toggle('flp-active',isCurrent);
      btn.setAttribute('aria-pressed',isCurrent?'true':'false');
    });
  }

  function updateSelectedValue(card){
    if(!card) return;
    selectedSkuCard=card;
    var launchSaving=Number(card.dataset.compare)-Number(card.dataset.price);
    var launchEl=document.getElementById('saveLaunch');
    var launchText=document.getElementById('saveLaunchText');
    if(launchEl) launchEl.textContent=money(launchSaving);
    if(launchText) launchText.textContent='Based on '+card.dataset.name+'.';
  }
  var colorSwatches=[].slice.call(document.querySelectorAll('.flp-color-swatch'));
  var selectedColor=(document.querySelector('.flp-color-swatch.flp-active')||colorSwatches[0]||{}).dataset ? (document.querySelector('.flp-color-swatch.flp-active')||colorSwatches[0]).dataset.color : 'Black';

  var COLOR_GALLERY={
    Black:[
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashblack_02.webp?v=1783808597',alt:'HMP FLASH in Black, side profile'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashblack_03.webp?v=1783808625',alt:'HMP FLASH in Black, front view with mirrors and windscreen'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashblack_04.webp?v=1783808576',alt:'HMP FLASH in Black, rear three-quarter view'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashblack01.webp?v=1781579351',alt:'HMP FLASH in Black, rear view with tire detail'}
    ],
    Gray:[
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashgray_02.webp?v=1783806886',alt:'HMP FLASH in Gray, front three-quarter view with LED headlight'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashgray_03.webp?v=1783806923',alt:'HMP FLASH in Gray, side profile'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashgray_04.webp?v=1783806937',alt:'HMP FLASH in Gray, front profile'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/Flashgray_05.webp?v=1783806952',alt:'HMP FLASH in Gray, rear view with tire detail'}
    ],
    White:[
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/0E4B5552.webp?v=1790610860',alt:'HMP FLASH 75 mph electric motorcycle in White, view 1'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/0E4B5553.webp?v=1790610860',alt:'HMP FLASH 75 mph electric motorcycle in White, view 2'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/0E4B5555.webp?v=1790610860',alt:'HMP FLASH 75 mph electric motorcycle in White, view 3'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/0E4B5557.webp?v=1790610860',alt:'HMP FLASH 75 mph electric motorcycle in White, view 4'},
      {src:'https://cdn.shopify.com/s/files/1/0600/1629/6074/files/0E4B5559.webp?v=1790610860',alt:'HMP FLASH 75 mph electric motorcycle in White, view 5'}
    ]
  };
  var flpColorHero=document.getElementById('flpColorHero');
  var flpColorThumbs=document.getElementById('flpColorThumbs');
  var flpHeroIndex=0;
  function renderColorGallery(color){
    var imgs=COLOR_GALLERY[color]||COLOR_GALLERY.Black;
    flpHeroIndex=0;
    if(flpColorHero){flpColorHero.src=imgs[0].src;flpColorHero.alt=imgs[0].alt;}
    if(flpColorThumbs){
      flpColorThumbs.innerHTML='';
      imgs.forEach(function(img,i){
        var btn=document.createElement('button');
        btn.type='button';
        btn.className='flp-color-thumb'+(i===0?' flp-active':'');
        btn.setAttribute('aria-label',img.alt);
        var thumbImg=document.createElement('img');
        thumbImg.src=img.src;thumbImg.alt='';thumbImg.loading='lazy';
        btn.appendChild(thumbImg);
        btn.addEventListener('click',function(){
          flpColorThumbs.querySelectorAll('button').forEach(function(b){b.classList.remove('flp-active')});
          btn.classList.add('flp-active');
          flpHeroIndex=i;
          if(flpColorHero){flpColorHero.src=img.src;flpColorHero.alt=img.alt;}
        });
        flpColorThumbs.appendChild(btn);
      });
    }
    document.querySelectorAll('.flp-battery-thumb').forEach(function(t){
      var idx=t.dataset.batteryThumb==='dual'?2:0;
      t.src=imgs[idx].src;
      t.alt='HMP FLASH '+(t.dataset.batteryThumb==='dual'?'dual':'single')+'-battery electric motorcycle in '+color;
    });
    if(flpLightbox&&flpLightbox.classList.contains('flp-open')){lbShow(0);}
  }

  // ---- Gallery lightbox: click/tap to zoom, pinch-zoom + drag-to-pan on mobile, wheel-zoom + double-click on desktop ----
  var flpLightbox=document.getElementById('flpLightbox');
  var flpLightboxImg=document.getElementById('flpLightboxImg');
  var flpLightboxStage=document.getElementById('flpLightboxStage');
  var flpLightboxClose=document.getElementById('flpLightboxClose');
  var flpLightboxPrev=document.getElementById('flpLightboxPrev');
  var flpLightboxNext=document.getElementById('flpLightboxNext');
  var flpLightboxCounter=document.getElementById('flpLightboxCounter');
  var flpGalleryMain=document.getElementById('flpColorGalleryMain');
  var lbIndex=0, lbScale=1, lbX=0, lbY=0;
  var lbPointers={}, lbStartDist=0, lbStartScale=1, lbLastTap=0;

  function currentGalleryImgs(){return COLOR_GALLERY[selectedColor]||COLOR_GALLERY.Black;}
  function lbApplyTransform(){
    if(flpLightboxImg) flpLightboxImg.style.transform='translate('+lbX+'px,'+lbY+'px) scale('+lbScale+')';
  }
  function lbReset(){lbScale=1;lbX=0;lbY=0;lbApplyTransform();}
  function lbRenderCurrent(){
    var imgs=currentGalleryImgs();
    if(!imgs.length||!flpLightboxImg) return;
    lbIndex=((lbIndex%imgs.length)+imgs.length)%imgs.length;
    flpLightboxImg.src=imgs[lbIndex].src;
    flpLightboxImg.alt=imgs[lbIndex].alt;
    if(flpLightboxCounter) flpLightboxCounter.textContent=(lbIndex+1)+' / '+imgs.length;
    lbReset();
  }
  function lbShow(delta){lbIndex+=delta;lbRenderCurrent();}
  function openLightbox(index){
    if(!flpLightbox) return;
    lbIndex=typeof index==='number'?index:flpHeroIndex;
    lbRenderCurrent();
    flpLightbox.classList.add('flp-open');
    document.body.style.overflow='hidden';
  }
  function closeLightbox(){
    if(!flpLightbox) return;
    flpLightbox.classList.remove('flp-open');
    document.body.style.overflow='';
  }
  if(flpGalleryMain){
    flpGalleryMain.addEventListener('click',function(){openLightbox(flpHeroIndex);});
    flpGalleryMain.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();openLightbox(flpHeroIndex);}});
  }
  if(flpLightboxClose) flpLightboxClose.addEventListener('click',closeLightbox);
  if(flpLightboxPrev) flpLightboxPrev.addEventListener('click',function(){lbShow(-1)});
  if(flpLightboxNext) flpLightboxNext.addEventListener('click',function(){lbShow(1)});
  if(flpLightbox){
    flpLightbox.addEventListener('click',function(e){if(e.target===flpLightbox){closeLightbox();}});
    document.addEventListener('keydown',function(e){
      if(!flpLightbox.classList.contains('flp-open')) return;
      if(e.key==='Escape') closeLightbox();
      if(e.key==='ArrowLeft') lbShow(-1);
      if(e.key==='ArrowRight') lbShow(1);
    });
    if(flpLightboxStage){
      flpLightboxStage.addEventListener('wheel',function(e){
        e.preventDefault();
        var delta=e.deltaY<0?0.18:-0.18;
        lbScale=Math.min(4,Math.max(1,lbScale+delta));
        if(lbScale===1){lbX=0;lbY=0;}
        lbApplyTransform();
      },{passive:false});
      flpLightboxStage.addEventListener('pointerdown',function(e){
        flpLightboxStage.setPointerCapture(e.pointerId);
        lbPointers[e.pointerId]={x:e.clientX,y:e.clientY};
        var ids=Object.keys(lbPointers);
        if(ids.length===2){
          var p1=lbPointers[ids[0]],p2=lbPointers[ids[1]];
          lbStartDist=Math.hypot(p2.x-p1.x,p2.y-p1.y);
          lbStartScale=lbScale;
        }
      });
      flpLightboxStage.addEventListener('pointermove',function(e){
        if(!lbPointers[e.pointerId]) return;
        var prev=lbPointers[e.pointerId];
        var ids=Object.keys(lbPointers);
        if(ids.length===2){
          lbPointers[e.pointerId]={x:e.clientX,y:e.clientY};
          var p1=lbPointers[ids[0]],p2=lbPointers[ids[1]];
          var dist=Math.hypot(p2.x-p1.x,p2.y-p1.y);
          if(lbStartDist>0){
            lbScale=Math.min(4,Math.max(1,lbStartScale*(dist/lbStartDist)));
            if(lbScale===1){lbX=0;lbY=0;}
            lbApplyTransform();
          }
        }else if(ids.length===1&&lbScale>1){
          var dx=e.clientX-prev.x,dy=e.clientY-prev.y;
          lbX+=dx;lbY+=dy;
          lbPointers[e.pointerId]={x:e.clientX,y:e.clientY};
          lbApplyTransform();
        }
      });
      function lbPointerEnd(e){
        delete lbPointers[e.pointerId];
        if(Object.keys(lbPointers).length<2) lbStartDist=0;
      }
      flpLightboxStage.addEventListener('pointerup',lbPointerEnd);
      flpLightboxStage.addEventListener('pointercancel',lbPointerEnd);
      flpLightboxStage.addEventListener('pointerleave',lbPointerEnd);
      flpLightboxStage.addEventListener('dblclick',function(){
        if(lbScale>1){lbReset();}else{lbScale=2.4;lbApplyTransform();}
      });
    }
    if(flpLightboxImg){
      flpLightboxImg.addEventListener('click',function(e){
        e.stopPropagation();
        var now=Date.now();
        if(now-lbLastTap<300){
          if(lbScale>1){lbReset();}else{lbScale=2.4;lbApplyTransform();}
        }
        lbLastTap=now;
      });
    }
  }

  renderColorGallery(selectedColor);

  // ---- Video showcase: click-to-load YouTube facades (avoids loading iframes until needed) ----
  // Note: YouTube's embedded player validates the page's origin. A file:// page (as used for
  // local double-click preview) has no valid https origin, so the inline iframe fails with a
  // generic "Error 153 / video player configuration error". On the live Shopify domain (https://)
  // this check passes and the inline embed works normally. To keep local preview usable, we
  // detect file:// and fall back to opening the real YouTube watch page in a new tab instead.
  var flpIsFileProtocol=(window.location.protocol==='file:');
  [].slice.call(document.querySelectorAll('.flp-video-facade')).forEach(function(btn){
    btn.addEventListener('click',function(){
      if(flpIsFileProtocol){
        var watchUrl=btn.dataset.watch;
        if(watchUrl) window.open(watchUrl,'_blank','noopener');
        return;
      }
      var embedUrl=btn.dataset.embed;
      if(!embedUrl) return;
      var frame=btn.closest('.flp-video-frame');
      if(!frame) return;
      var iframe=document.createElement('iframe');
      iframe.src=embedUrl;
      iframe.title=btn.getAttribute('aria-label')||'Video';
      iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen=true;
      var sourceTag=frame.querySelector('.flp-video-source');
      frame.innerHTML='';
      frame.appendChild(iframe);
      if(sourceTag) frame.appendChild(sourceTag);
    });
  });

  // ---- Photo gallery: horizontal scroll carousel with prev/next buttons ----
  // Supports multiple independent gallery instances on the same page (each .flp-gallery-shell
  // owns its own track + prev/next buttons, scoped with closest()/querySelector rather than IDs).
  [].slice.call(document.querySelectorAll('.flp-gallery-shell')).forEach(function(shell){
    var track=shell.querySelector('.flp-gallery-track');
    var prevBtn=shell.querySelector('.flp-gallery-prev');
    var nextBtn=shell.querySelector('.flp-gallery-next');
    if(!track||!prevBtn||!nextBtn) return;
    function flpGalleryStep(){
      var slide=track.querySelector('.flp-gallery-slide');
      var gap=14;
      return slide?slide.getBoundingClientRect().width+gap:300;
    }
    function flpGalleryUpdateButtons(){
      var max=track.scrollWidth-track.clientWidth-4;
      prevBtn.disabled=track.scrollLeft<=4;
      nextBtn.disabled=track.scrollLeft>=max;
    }
    prevBtn.addEventListener('click',function(){
      track.scrollBy({left:-flpGalleryStep()*2,behavior:'smooth'});
    });
    nextBtn.addEventListener('click',function(){
      track.scrollBy({left:flpGalleryStep()*2,behavior:'smooth'});
    });
    track.addEventListener('scroll',flpGalleryUpdateButtons);
    window.addEventListener('resize',flpGalleryUpdateButtons);
    flpGalleryUpdateButtons();
  });

  var selectedVariantIdInput=document.getElementById('selectedVariantId');
  var flpMainBuyBtnPrice=document.getElementById('flpMainBuyBtnPrice');
  var buildTotal=document.getElementById('buildTotal');
  var buildLineBike=document.getElementById('buildLineBike');
  var buildLineBikePrice=document.getElementById('buildLineBikePrice');
  var buildLineRack=document.getElementById('buildLineRack');
  var addonToggles=[].slice.call(document.querySelectorAll('.flp-addon-toggle'));
  var addonState={rack:true,grips:false,key:false};
  var gripsLockedByObc=false;

  // ---------------------------------------------------------------------
  // Sold-out builds: $200 refundable reservation + back-in-stock capture.
  // ---------------------------------------------------------------------
  // Real variant of "FLASH Reservation Deposit - $200 (Refundable, FLASH Electric
  // Motorcycle Only)" -- renamed 2026-07-30; it used to say "e-Bike", which was wrong
  // (FLASH is an electric motorcycle) and was also why the automated "Electric Bikes"
  // collection had picked the deposit up: its rule is TITLE CONTAINS "E-bike".
  // Product gid://shopify/Product/9216222724234, SKU FLASH-DEP-200,
  // created 2026-07-30. Set ACTIVE and published to the Online Store channel on
  // 2026-07-30 05:11:57Z. BOTH are required and they are separate switches: an ACTIVE
  // product that is not published to that channel still makes /cart/add.js reject the
  // add -- that missing publication is exactly why this button did nothing on the
  // first live test.
  var FLP_DEPOSIT_VARIANT_ID=49815354441866;
  var FLP_DEPOSIT_AMOUNT=200;
  // file:// previews have no Shopify cart/contact backend, so both flows show
  // their intended end state instead of failing.
  var flpDemoMode=(location.protocol==='file:');
  // Inside the theme editor the preview iframe refuses top-level navigation, so
  // window.location.href='/checkout' silently does nothing at all there. That is why
  // the button appeared to hang on "Reserving…" while the add had in fact succeeded.
  var flpDesignMode=!!(window.Shopify&&window.Shopify.designMode);
  var flpLastReserveLabel='';

  // DOM truth beats the module variable here: selectSku() calls flpSetBuyMode() BEFORE
  // updateSelectedValue() assigns selectedSkuCard, so inside these helpers that variable
  // still points at the PREVIOUSLY selected card -- which parented the reserve panel
  // under the wrong model group. The .flp-selected class is applied at the top of
  // selectSku(), so it is always the card the shopper just clicked.
  function flpSelectedCard(){
    return document.querySelector('.flp-sku-card.flp-selected')||selectedSkuCard;
  }
  function flpCurrentBuildLabel(){
    var c=flpSelectedCard();
    return c?(c.dataset.name+' — '+selectedColor):'';
  }
  // The deposit locks the bike + color ONLY (decision 2026-07-30). The reserve panel
  // now sits up inside the model card, well above the add-ons block, so a shopper
  // reading it has not even seen the accessories yet -- locking a total that included
  // them would be quoting a price for things he never picked. Accessories get added
  // at the balance stage instead.
  function flpBikePrice(){
    var c=flpSelectedCard();
    return c?(Number(c.dataset.price)||0):0;
  }
  // Collapses the email half back to the single "Email me when it's back" button.
  // Deliberately does NOT touch the local-preview <details>: closing the form should
  // not throw away a properties preview the shopper just expanded.
  function flpCloseNotify(refocus){
    var open=document.getElementById('flpNotifyOpen');
    var panel=document.getElementById('flpNotifyForm');
    if(open) open.hidden=false;
    if(panel) panel.hidden=true;
    if(refocus&&open) open.focus();
  }
  // Horizon cart plumbing for the reserve path. Deliberately a second copy of what the
  // main buy button does further down rather than a shared helper: those two are function
  // declarations nested inside `if(flpMainBuyForm){...}`, so reaching them from here would
  // lean on Annex B block-function hoisting, and the main buy path works -- it is not
  // getting refactored to serve this one.
  function flpCartRefreshBubble(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(cart){
        var count=cart.item_count;
        var icon=document.querySelector('cart-icon');
        if(icon){
          var c=icon.querySelector('[ref="cartBubbleCount"]');
          var b=icon.querySelector('[ref="cartBubble"]');
          if(c){c.textContent=count<100?String(count):'';c.classList.toggle('hidden',count===0);}
          if(b){b.classList.toggle('visually-hidden',count===0);}
          icon.classList.toggle('header-actions__cart-icon--has-cart',count>0);
          try{sessionStorage.setItem('cart-count',JSON.stringify({value:String(count),timestamp:Date.now()}));}catch(e){}
        }
        document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=count;});
        return cart;
      }).catch(function(){return null;});
  }
  function flpCartFly(button){
    var cartIcon=document.querySelector('.header-actions__cart-icon');
    if(!cartIcon||!button||!(window.customElements&&customElements.get('fly-to-cart'))) return;
    try{
      var fly=document.createElement('fly-to-cart');
      fly.classList.add('fly-to-cart--main');
      fly.source=button; fly.destination=cartIcon;
      document.body.appendChild(fly);
    }catch(e){}
  }
  // Returns the reserve button to its idle state and clears whichever outcome box is on
  // screen -- the red failure OR the green confirmation. Module-level (not a closure
  // inside the click handler) because switching build also has to clear a stale result;
  // see flpResetNotify below.
  function flpReserveResetState(){
    var btn=document.getElementById('flpReserveBtn');
    if(btn){
      btn.classList.remove('flp-reserve-loading');
      btn.classList.remove('flp-reserve-failed');
      btn.classList.remove('flp-reserve-added');
      btn.disabled=false;
      var s=btn.querySelector('.flp-reserve-btn-status');
      if(s) s.textContent='';
    }
    var box=document.getElementById('flpReserveError');
    if(box){box.hidden=true;box.textContent='';}
    var done=document.getElementById('flpReserveDone');
    if(done){done.hidden=true;done.textContent='';}
  }
  function flpResetNotify(){
    flpCloseNotify(false);
    var demo=document.getElementById('flpReserveDemo');
    if(demo){demo.hidden=true;demo.open=false;demo.innerHTML='';}
    flpReserveResetState();
  }
  function flpRefreshReserve(){
    var panel=document.getElementById('flpReserve');
    if(!panel||panel.hidden) return;
    var label=flpCurrentBuildLabel();
    // Switching to a different build invalidates any confirmation still on screen.
    if(label!==flpLastReserveLabel){flpLastReserveLabel=label;flpResetNotify();}
    var total=flpBikePrice(),el;
    if((el=document.getElementById('flpReserveBuild'))) el.textContent=label;
    if((el=document.getElementById('flpReservePrice'))) el.textContent=money(total);
    if((el=document.getElementById('flpNotifyBuild'))) el.textContent=label;
  }
  function flpSetBuyMode(soldOut){
    var form=document.getElementById('flpMainBuyForm');
    var panel=document.getElementById('flpReserve');
    var note=document.getElementById('flpSoldOutNote');
    if(!panel) return;
    // Any failure still on screen belongs to the previous attempt. The label-change
    // guard inside flpRefreshReserve() does NOT catch re-selecting the SAME sold-out
    // build after a detour through an in-stock one, so clear it here, where every
    // configuration change lands.
    flpReserveResetState();
    if(form) form.hidden=!!soldOut;
    if(note) note.hidden=!soldOut;
    panel.hidden=!soldOut;
    if(!soldOut){
      // Leaving the sold-out state closes the email panel too, and forgets which build
      // it was opened for. flpRefreshReserve() early-returns while the panel is hidden,
      // so without this the remembered label goes stale, and returning to the SAME
      // sold-out build via an in-stock one would re-show an already-dismissed panel.
      flpLastReserveLabel='';
      flpCloseNotify(false);
    }
    if(soldOut){
      // Re-parent the panel into the sku grid of the card that was just clicked.
      // It used to live down in the buy area, after the add-ons block and the build
      // summary -- two or three screens away -- so clicking a sold-out card looked
      // like nothing happened at all. ONE instance is moved rather than duplicated,
      // so every id in here stays unique.
      var card=flpSelectedCard();
      var group=(card&&card.closest)?card.closest('.flp-sku-options'):null;
      if(group&&panel.parentNode!==group) group.appendChild(panel);
      flpRefreshReserve();
    }
  }

  var flpSoldOutJump=document.getElementById('flpSoldOutJump');
  if(flpSoldOutJump){
    flpSoldOutJump.addEventListener('click',function(){
      var panel=document.getElementById('flpReserve');
      if(panel&&!panel.hidden) panel.scrollIntoView({behavior:'smooth',block:'center'});
    });
  }

  var flpReserveBtn=document.getElementById('flpReserveBtn');
  if(flpReserveBtn){
    flpReserveBtn.addEventListener('click',function(){
      var card=flpSelectedCard();
      if(!card||flpReserveBtn.disabled) return;
      var statusEl=flpReserveBtn.querySelector('.flp-reserve-btn-status');
      flpReserveResetState();
      flpReserveBtn.disabled=true;
      flpReserveBtn.classList.add('flp-reserve-loading');
      if(statusEl) statusEl.textContent='Reserving…';

      var total=flpBikePrice();

      // Line item properties are the whole mechanism here: they ride along on the
      // $200 deposit order so the exact build and locked price are visible in Admin
      // and can be turned into a balance draft order later. Deliberately only three:
      // anything derivable (balance = locked price - 200) or meaningless to the
      // shopper (raw variant ID) is left off.
      var props={
        'Reserved build':card.dataset.name+' — '+selectedColor,
        'Locked price':money(total),
        'Reserved on':new Date().toISOString().slice(0,10)
      };

      // Composed with DOM nodes rather than innerHTML: `why` can contain the raw text
      // of a Shopify error response, and there is no reason to hand that to an HTML
      // parser.
      function flpReserveFail(why){
        flpReserveBtn.classList.remove('flp-reserve-loading');
        flpReserveBtn.classList.add('flp-reserve-failed');
        flpReserveBtn.disabled=false;
        if(statusEl) statusEl.textContent='Try again';
        var box=document.getElementById('flpReserveError');
        if(box){
          box.textContent='';
          var b=document.createElement('b');
          b.textContent='We couldn’t start your reservation. ';
          box.appendChild(b);
          box.appendChild(document.createTextNode(why+' Try again, or email business@hmpbikes.com and we’ll hold this build for you manually.'));
          box.hidden=false;
        }
        if(window.console&&console.warn) console.warn('[FLASH reserve] deposit add failed: '+why);
      }

      // The add SUCCEEDED but the shopper is still on this page. Two ways that happens:
      // in the theme editor a top-level jump to /checkout is refused outright, and on a
      // live page the redirect can be slow, blocked or cancelled. Before this existed
      // the only success branch was the redirect itself, so when it did not happen the
      // button sat at "Reserving…" forever while the deposit was already in the cart --
      // exactly what was reported on 2026-07-30.
      function flpReserveConfirm(why){
        flpReserveBtn.classList.remove('flp-reserve-loading');
        flpReserveBtn.classList.add('flp-reserve-added');
        flpReserveBtn.disabled=false;
        if(statusEl) statusEl.textContent='Deposit in cart ✓';
        var box=document.getElementById('flpReserveDone');
        if(box){
          box.textContent='';
          var b=document.createElement('b');
          b.textContent='$200 deposit added to your cart. ';
          box.appendChild(b);
          if(why) box.appendChild(document.createTextNode(why+' '));
          var a=document.createElement('a');
          a.className='flp-reserve-done-link';
          a.href='/checkout';
          // In the editor the iframe refuses the in-place jump, so the link has to leave
          // the iframe to be of any use. On a real page a new tab would be hostile, so
          // there it navigates in place.
          if(flpDesignMode){a.target='_blank';a.rel='noopener';}
          a.textContent='Continue to checkout →';
          box.appendChild(a);
          box.hidden=false;
          box.scrollIntoView({behavior:'smooth',block:'nearest'});
        }
      }

      if(flpDemoMode||!FLP_DEPOSIT_VARIANT_ID){
        setTimeout(function(){
          var demo=document.getElementById('flpReserveDemo');
          if(demo){
            var rows='';
            for(var k in props){ if(Object.prototype.hasOwnProperty.call(props,k)) rows+='<div class="flp-reserve-row"><span>'+k+'</span><b>'+props[k]+'</b></div>'; }
            demo.innerHTML='<summary>Local preview — what Shopify would record</summary><div class="flp-reserve-demo-body">'+rows+'<p class="flp-reserve-fine">In the live store this button adds the $200 deposit and goes straight to checkout. This box does not exist online.</p></div>';
            demo.hidden=false;
            demo.open=false;
            demo.scrollIntoView({behavior:'smooth',block:'nearest'});
          }
          flpReserveResetState();
        },500);
        return;
      }

      // ------------------------------------------------------------------
      // Horizon cart sync -- the same contract the main buy button uses. The
      // drawer (cart-items-component), the bubble (cart-icon) and the a11y
      // announcer re-render ONLY in response to a 'shopify:cart:lines-update'
      // event carrying a promise that resolves to {cart, detail}. A bare
      // /cart/add.js mutates the cart server-side and leaves the drawer showing
      // the "empty" HTML it was served at page load, which is why the deposit
      // only became visible after navigating to another page.
      // ------------------------------------------------------------------
      var flpPrevCount=0;
      try{
        var flpBubble=document.querySelector('cart-icon [ref="cartBubbleCount"]');
        flpPrevCount=flpBubble?(parseInt(flpBubble.textContent||'0',10)||0):0;
      }catch(e){}
      var flpDeferred={};
      var flpEvPromise=new Promise(function(res,rej){flpDeferred.resolve=res;flpDeferred.reject=rej;});
      flpEvPromise.catch(function(){}); // no unhandled-rejection noise if no listener attached
      try{
        var flpEv=new Event('shopify:cart:lines-update',{bubbles:true,cancelable:true});
        flpEv.action='add';
        flpEv.promise=flpEvPromise;
        flpReserveBtn.dispatchEvent(flpEv);
      }catch(e){}
      var flpSectionIds=[];
      document.querySelectorAll('cart-items-component').forEach(function(el){
        if(el.dataset&&el.dataset.sectionId&&flpSectionIds.indexOf(el.dataset.sectionId)===-1) flpSectionIds.push(el.dataset.sectionId);
      });
      var flpPayload={items:[{id:Number(FLP_DEPOSIT_VARIANT_ID),quantity:1,properties:props}]};
      if(flpSectionIds.length){flpPayload.sections=flpSectionIds.join(',');flpPayload.sections_url=window.location.pathname;}
      flpCartFly(flpReserveBtn);

      // Read the body even on a non-2xx: /cart/add.js answers 422 with a JSON
      // {status, message, description} that says WHY (unavailable variant, product not
      // published to this channel, sold out, ...). The old code threw a fixed string
      // away instead, which left nothing to diagnose from.
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},credentials:'same-origin',
        body:JSON.stringify(flpPayload)})
        .then(function(r){
          return r.text().then(function(t){
            var data=null; try{data=JSON.parse(t);}catch(e){}
            if(!r.ok){
              throw new Error((data&&(data.description||data.message))||('The store returned HTTP '+r.status+'.'));
            }
            return data;
          });
        })
        .then(function(data){
          if(statusEl) statusEl.textContent='Added ✓';
          var flpSections=(data&&data.sections)?data.sections:null;
          flpCartRefreshBubble().then(function(cart){
            var n=(cart&&typeof cart.item_count==='number')?cart.item_count:(flpPrevCount+1);
            flpDeferred.resolve({
              cart:{totalQuantity:n},
              detail:{sections:flpSections,itemCount:n,source:'flash-landing-reserve',didError:false}
            });
          });
          if(flpDesignMode){
            flpReserveConfirm('Checkout opens in a new tab from the theme preview.');
            return;
          }
          // Let the fly-to-cart animation and the drawer refresh be seen before leaving,
          // then hand over to checkout. The inner timer is the watchdog: if the jump is
          // refused or never lands, the shopper ends up in a state that tells the truth
          // and holds a link he can click himself, instead of a frozen button.
          setTimeout(function(){
            setTimeout(function(){ flpReserveConfirm(''); },2500);
            window.location.href='/checkout';
          },900);
        })
        .catch(function(e){
          var flpErr=new Error('flash landing reserve add failed');
          flpErr.name='AbortError'; // Horizon's listeners ignore AbortError rejections silently
          flpDeferred.reject(flpErr);
          flpReserveFail((e&&e.message)?String(e.message):'The request could not be sent.');
        });
    });
  }

  var flpNotifyOpenBtn=document.getElementById('flpNotifyOpen');
  var flpNotifyFormEl=document.getElementById('flpNotifyForm');
  if(flpNotifyOpenBtn&&flpNotifyFormEl){
    flpNotifyOpenBtn.addEventListener('click',function(){
      flpNotifyOpenBtn.hidden=true;
      flpNotifyFormEl.hidden=false;
      // The live field lives in the Forms shadow root and cannot be focused from here;
      // this only bites on the local stand-in, where it is a genuine input.
      var i=flpNotifyFormEl.querySelector('input');
      if(i&&i.focus) i.focus();
    });
    // Manual escape hatch: the form used to be a one-way door -- once open there was no
    // way back to the compact two-button row short of switching configuration.
    var flpNotifyCloseBtn=document.getElementById('flpNotifyClose');
    if(flpNotifyCloseBtn){
      flpNotifyCloseBtn.addEventListener('click',function(){ flpCloseNotify(true); });
    }
    flpNotifyFormEl.addEventListener('keydown',function(e){
      if(e.key==='Escape'||e.keyCode===27){ e.stopPropagation(); flpCloseNotify(true); }
    });
  }

  function currentVariantId(card){
    if(!card) return null;
    var attr=('variant'+selectedColor) in card.dataset ? 'variant'+selectedColor : 'variantBlack';
    return card.dataset[attr]||null;
  }

  function refreshBuild(){
    var card=selectedSkuCard||document.querySelector('.flp-sku-card.flp-selected');
    if(!card) return;
    var bikePrice=Number(card.dataset.price);
    var fullName=card.dataset.name+' — '+selectedColor;
    if(buildLineBike) buildLineBike.textContent=fullName;
    if(buildLineBikePrice) buildLineBikePrice.textContent=money(bikePrice);

    // Grips gets its own itemized line only when it's a genuine paid add-on the shopper
    // chose. When it's bundled into the OBC bike price, it's already inside bikePrice
    // above — listing it again as a separate line would misleadingly suggest it was
    // added on top, so it's left out entirely in that case.
    var gripsLine=document.getElementById('buildLineGrips');
    if(addonState.grips && !gripsLockedByObc){
      if(!gripsLine && buildLineRack){
        gripsLine=document.createElement('div');
        gripsLine.className='flp-build-line';
        gripsLine.id='buildLineGrips';
        buildLineRack.parentNode.appendChild(gripsLine);
      }
      if(gripsLine) gripsLine.innerHTML='<b>FLASH Heated Grips</b><span>'+money(99)+'</span>';
    }else if(gripsLine){
      gripsLine.remove();
    }
    if(buildLineRack) buildLineRack.style.display=addonState.rack?'':'none';

    // Remote key is a simple independent paid add-on — no bundling/locking logic
    // like grips has with OBC, it's just on or off.
    var keyLine=document.getElementById('buildLineKey');
    if(addonState.key){
      if(!keyLine && buildLineRack){
        keyLine=document.createElement('div');
        keyLine.className='flp-build-line';
        keyLine.id='buildLineKey';
        buildLineRack.parentNode.appendChild(keyLine);
      }
      if(keyLine) keyLine.innerHTML='<b>FLASH Remote Key</b><span>'+money(49)+'</span>';
    }else if(keyLine){
      keyLine.remove();
    }

    var total=bikePrice+((addonState.grips&&!gripsLockedByObc)?99:0)+(addonState.key?49:0);
    if(buildTotal) buildTotal.textContent=money(total);
    if(flpMainBuyBtnPrice) flpMainBuyBtnPrice.textContent=money(total);
    flpRefreshReserve();
  }

  function selectSku(card){
    // Sold-out builds are intentionally selectable now: picking one swaps the buy
    // area over to the reservation / notify-me panel instead of silently bouncing
    // the shopper back to the in-stock Portable build.
    skuCards.forEach(function(c){c.classList.remove('flp-selected');c.setAttribute('aria-pressed','false')});
    card.classList.add('flp-selected');
    card.setAttribute('aria-pressed','true');
    selectedName.textContent=card.dataset.name+' — '+selectedColor;
    var dual=card.dataset.sku.indexOf('dual')===0;
    var obc=card.dataset.chargeType==='obc';
    selectedDescription.textContent=(dual?'75 mph, 70–85 miles of SF range':'60 mph, about 40 miles of SF range')+', '+(obc?'faster direct-to-bike J1772 / 200–240V charging plus removable batteries.':'840 W portable charging on-bike or off-bike.');

    var gripsToggle=document.getElementById('addonGrips');
    if(obc){
      gripsLockedByObc=true;
      addonState.grips=true;
      if(gripsToggle){
        gripsToggle.classList.remove('flp-addon-selected');
        gripsToggle.classList.add('flp-addon-included');
        gripsToggle.setAttribute('aria-pressed','true');
        gripsToggle.setAttribute('aria-disabled','true');
      }
    }else if(gripsLockedByObc){
      gripsLockedByObc=false;
      addonState.grips=false; // leaving OBC always resets to unchecked — user must actively opt in again
      if(gripsToggle){
        gripsToggle.classList.remove('flp-addon-included','flp-addon-selected');
        gripsToggle.setAttribute('aria-pressed','false');
        gripsToggle.removeAttribute('aria-disabled');
      }
    }

    flpSetBuyMode(card.classList.contains('flp-sold-out'));
    updateSelectedValue(card);
    if(selectedVariantIdInput){
      var vid=currentVariantId(card);
      if(vid) selectedVariantIdInput.value=vid;
    }
    refreshBuild();
  }
  skuCards.forEach(function(card){card.addEventListener('click',function(){selectSku(card)})});
  colorSwatches.forEach(function(sw){
    sw.addEventListener('click',function(){
      colorSwatches.forEach(function(s){s.classList.remove('flp-active');s.setAttribute('aria-pressed','false')});
      sw.classList.add('flp-active');sw.setAttribute('aria-pressed','true');
      selectedColor=sw.dataset.color;
      renderColorGallery(selectedColor);
      selectSku(selectedSkuCard||document.querySelector('.flp-sku-card.flp-selected'));
    });
  });

  function toggleAddon(toggle){
    var key=toggle.dataset.addon;
    addonState[key]=!addonState[key];
    toggle.classList.toggle('flp-addon-selected',addonState[key]);
    toggle.setAttribute('aria-pressed',addonState[key]?'true':'false');
    refreshBuild();
  }
  addonToggles.forEach(function(toggle){
    // toggle is a role="button" div (not a native <button>) so it can contain the
    // real "View product details" <a> link — buttons can't nest interactive children.
    toggle.addEventListener('click',function(e){
      if(e.target.closest('.flp-addon-link')) return; // let the link navigate, don't toggle selection
      if(toggle.classList.contains('flp-addon-included')) return; // bundled with current SKU, not user-toggleable
      toggleAddon(toggle);
    });
    toggle.addEventListener('keydown',function(e){
      if(e.target.closest('.flp-addon-link')) return;
      if(toggle.classList.contains('flp-addon-included')) return;
      if(e.key==='Enter'||e.key===' '){
        e.preventDefault();
        toggleAddon(toggle);
      }
    });
  });

  var flpMainBuyForm=document.getElementById('flpMainBuyForm');
  if(flpMainBuyForm){
    function mainCartUpdateCount(){
      return fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
        .then(function(r){return r.json();})
        .then(function(cart){
          var count=cart.item_count;
          var icon=document.querySelector('cart-icon');
          if(icon){
            var c=icon.querySelector('[ref="cartBubbleCount"]');
            var b=icon.querySelector('[ref="cartBubble"]');
            if(c){c.textContent=count<100?String(count):'';c.classList.toggle('hidden',count===0);}
            if(b){b.classList.toggle('visually-hidden',count===0);}
            icon.classList.toggle('header-actions__cart-icon--has-cart',count>0);
            try{sessionStorage.setItem('cart-count',JSON.stringify({value:String(count),timestamp:Date.now()}));}catch(e){}
          }
          document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=count;});
          return cart;
        }).catch(function(){return null;});
    }
    function mainFlyToCart(button){
      var cartIcon=document.querySelector('.header-actions__cart-icon');
      if(!cartIcon||!button||!(window.customElements&&customElements.get('fly-to-cart'))) return;
      try{
        var fly=document.createElement('fly-to-cart');
        fly.classList.add('fly-to-cart--main');
        fly.source=button; fly.destination=cartIcon;
        document.body.appendChild(fly);
      }catch(e){}
    }
    flpMainBuyForm.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=document.getElementById('flpMainBuyBtn'); if(!btn||btn.disabled) return;
      // The price span (#flpMainBuyBtnPrice) is a persistent node that refreshBuild() writes to
      // via a long-lived reference. It must never be destroyed/recreated (e.g. via btn.innerHTML=…)
      // while showing loading/success text, or that reference goes stale and the button price
      // silently stops updating on every subsequent selection change. A dedicated status span is
      // toggled instead, leaving the idle label (and the price span inside it) untouched in the DOM.
      var statusEl=btn.querySelector('.flp-buybtn-status');
      btn.disabled=true; btn.classList.add('flp-buybtn-loading'); if(statusEl) statusEl.textContent='Adding…';
      mainFlyToCart(btn);

      var items=[{id:Number(selectedVariantIdInput.value),quantity:1}];
      if(addonState.rack){
        var rackToggle=document.getElementById('addonRack');
        items.push({id:Number(rackToggle.dataset.variantId),quantity:1});
      }
      if(addonState.grips){
        var gripsToggle=document.getElementById('addonGrips');
        items.push({id:Number(gripsToggle.dataset.variantId),quantity:1});
      }
      if(addonState.key){
        var keyToggle=document.getElementById('addonKey');
        items.push({id:Number(keyToggle.dataset.variantId),quantity:1});
      }

      // ---------------------------------------------------------------------
      // Horizon cart sync. The theme's cart drawer (cart-items-component),
      // cart icon bubble (cart-icon) and a11y announcer (header-actions) all
      // re-render ONLY in response to a 'shopify:cart:lines-update' event
      // (StandardEvents.cartLinesUpdate) carrying a promise that resolves to
      // { cart, detail }. A bare fetch('/cart/add.js') mutates the cart
      // server-side but leaves the drawer showing its server-rendered state
      // from page load — i.e. "Your cart is empty" until the next navigation.
      // So: dispatch the event first (exactly like the theme's own
      // product-form / cart-items components do), request the drawer section
      // HTML in the same add.js call via bundled section rendering, then
      // resolve the promise. cart-items-component morphs the new HTML in (or
      // refetches the section if HTML is missing) and cart-drawer-component
      // auto-opens the drawer when the theme's auto-open setting is on.
      // ---------------------------------------------------------------------
      var flpPrevCount=0;
      try{
        var flpBubbleEl=document.querySelector('cart-icon [ref="cartBubbleCount"]');
        flpPrevCount=flpBubbleEl?(parseInt(flpBubbleEl.textContent||'0',10)||0):0;
      }catch(e){}
      var flpAddedQty=items.reduce(function(s,it){return s+(it.quantity||0);},0);

      var flpDeferred={};
      var flpEvPromise=new Promise(function(res,rej){flpDeferred.resolve=res;flpDeferred.reject=rej;});
      flpEvPromise.catch(function(){}); // avoid unhandled-rejection noise if no theme listener attached
      try{
        var flpEv=new Event('shopify:cart:lines-update',{bubbles:true,cancelable:true});
        flpEv.action='add';
        flpEv.promise=flpEvPromise;
        btn.dispatchEvent(flpEv);
      }catch(e){}

      var flpSectionIds=[];
      document.querySelectorAll('cart-items-component').forEach(function(el){
        if(el.dataset&&el.dataset.sectionId&&flpSectionIds.indexOf(el.dataset.sectionId)===-1) flpSectionIds.push(el.dataset.sectionId);
      });
      var flpPayload={items:items};
      if(flpSectionIds.length){flpPayload.sections=flpSectionIds.join(',');flpPayload.sections_url=window.location.pathname;}

      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(flpPayload),credentials:'same-origin'})
        .then(function(r){return r.json().then(function(d){return {ok:r.ok,data:d};});})
        .then(function(res){
          if(!res.ok) throw new Error('add failed');
          if(statusEl) statusEl.textContent='Added to cart ✓';
          var flpSections=(res.data&&res.data.sections)?res.data.sections:null;
          mainCartUpdateCount().then(function(cart){
            var flpCount=(cart&&typeof cart.item_count==='number')?cart.item_count:(flpPrevCount+flpAddedQty);
            flpDeferred.resolve({
              cart:{totalQuantity:flpCount},
              detail:{sections:flpSections,itemCount:flpCount,source:'flash-landing',didError:false}
            });
          });
          setTimeout(function(){btn.classList.remove('flp-buybtn-loading');btn.disabled=false;},1800);
        })
        .catch(function(){
          var flpErr=new Error('flash landing add-to-cart failed');
          flpErr.name='AbortError'; // Horizon's listeners silently ignore AbortError rejections
          flpDeferred.reject(flpErr);
          if(statusEl) statusEl.textContent='Try again';
          setTimeout(function(){btn.classList.remove('flp-buybtn-loading');btn.disabled=false;},1800);
        });
    });
  }
  refreshBuild();

  var distOptions=[].slice.call(document.querySelectorAll('.flp-dist-option'));
  function currentBattChoice(){
    var active=document.querySelector('.flp-dist-option.flp-active');
    return active?active.dataset.batt:'single';
  }
  function isCardInStock(card){
    return !!card && !card.classList.contains('flp-sold-out') && !card.disabled;
  }
  function updateRecommendation(){
    var batt=currentBattChoice();
    var mode=(document.querySelector('.flp-quiz-option.flp-active')||{}).dataset ? document.querySelector('.flp-quiz-option.flp-active').dataset.charge : 'apartment';
    var portableCard=document.querySelector('[data-sku="'+batt+'-portable"]');
    var obcCard=document.querySelector('[data-sku="'+batt+'-obc"]');
    var obcInStock=isCardInStock(obcCard);
    var wantsObc=(mode==='garage'||mode==='mixed');
    var targetCard=(wantsObc&&obcInStock)?obcCard:portableCard;
    var targetChargeType=(targetCard===obcCard)?'obc':'portable';

    skuCards.forEach(function(c){c.classList.remove('flp-recommended-choice')});
    skuCards.filter(function(c){return c.dataset.chargeType===targetChargeType}).forEach(function(c){c.classList.add('flp-recommended-choice')});

    if(mode==='garage'){
      reason.textContent=obcInStock
        ? 'The 2 kW onboard system matches what you asked for — faster direct-to-bike charging.'
        : 'The 2 kW Onboard Charger you wanted is currently sold out, so we’re recommending the 840 W Portable Charger instead — it ships today, on or off the bike.';
    }else if(mode==='mixed'){
      reason.textContent=obcInStock
        ? 'The 2 kW onboard system keeps both packs removable while adding faster direct-to-bike charging.'
        : 'The 2 kW Onboard Charger is currently sold out. The 840 W Portable Charger still keeps both packs removable for indoor charging.';
    }else{
      reason.textContent='Charge with the battery installed in FLASH, or remove it and charge indoors.';
    }
    recommendation.textContent=(batt==='dual'?'FLASH Dual':'FLASH Single')+' · '+(targetChargeType==='obc'?'2 kW Onboard Charger':'840 W Portable Charger');
    selectSku(targetCard);
  }
  distOptions.forEach(function(opt){
    opt.addEventListener('click',function(){
      distOptions.forEach(function(o){o.classList.remove('flp-active');o.setAttribute('aria-pressed','false')});
      opt.classList.add('flp-active');opt.setAttribute('aria-pressed','true');
      updateRecommendation();
    });
  });
  quizOptions.forEach(function(option){option.addEventListener('click',function(){
    quizOptions.forEach(function(o){o.classList.remove('flp-active');o.setAttribute('aria-pressed','false')}); option.classList.add('flp-active');option.setAttribute('aria-pressed','true');
    updateRecommendation();
  })});

  if(saveMiles){
    ['input','change'].forEach(function(evt){
      saveMiles.addEventListener(evt,function(){
        ridePresets.forEach(function(p){p.classList.toggle('flp-active',Number(p.dataset.miles)===Number(saveMiles.value))});
        updateSavings();
      });
      saveGas.addEventListener(evt,updateSavings);
      saveElectric.addEventListener(evt,updateSavings);
      if(saveLabor) saveLabor.addEventListener(evt,updateSavings);
      if(saveYearsRange) saveYearsRange.addEventListener(evt,function(){saveYears=Number(saveYearsRange.value);updateSavings();});
    });
    ridePresets.forEach(function(button){button.addEventListener('click',function(){
      saveMiles.value=button.dataset.miles;
      ridePresets.forEach(function(p){p.classList.remove('flp-active')});
      button.classList.add('flp-active');
      updateSavings();
    })});
    yearOptions.forEach(function(button){button.addEventListener('click',function(){
      saveYears=Number(button.dataset.years);
      yearOptions.forEach(function(y){y.classList.remove('flp-active')});
      button.classList.add('flp-active');
      updateSavings();
    })});
    updateSelectedValue(selectedSkuCard);
    updateSavings();
  }

  if(fitHeight){
    ['input','change'].forEach(function(evt){fitHeight.addEventListener(evt,updateFit)});
    fitPresets.forEach(function(button){button.addEventListener('click',function(){
      fitHeight.value=button.dataset.height;
      updateFit();
    })});
    updateFit();
  }
})();


(function(){
  var menu=document.querySelector('.flp-mobile-menu');
  if(!menu) return;
  menu.querySelectorAll('a').forEach(function(link){
    link.addEventListener('click',function(){menu.removeAttribute('open')});
  });
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&menu.open){menu.removeAttribute('open');menu.querySelector('summary').focus()}
  });
})();
})();
